import { defineNuxtPlugin } from "#imports";


const GA_TRACKING_ID = "UA-220329376-1";

declare global {
	interface Window { gtag: Function; Tracker: { send: Function } }
}


export default defineNuxtPlugin((nuxtApp) => {
	if (process.client) {
		nuxtApp.hook('page:start', () => {
			if (process.client) {
				/*console.log("page:start", window.gtag, window.location.toString());
				if (window.gtag) {
					window.gtag('config', GA_TRACKING_ID, {
						page_path: window.location.toString(),
					});
				}*/
			}

		});
		nuxtApp.hook('app:created', () => {
			if (process.client) {
				/*console.log("page:created", window.gtag, window.location.toString());
				if (window.gtag) {
					window.gtag('config', GA_TRACKING_ID, {
						page_path: window.location.toString(),
					});
				}*/
			}
		});
	}
})
